import { AwsRumProvider as AwsRumReact } from "aws-rum-react";
import ErrorBoundary from "./ErrorBoundary";
import { config } from "common/config";
import { PropsWithChildren } from "react";

function AwsRumProvider({ children }: PropsWithChildren<unknown>) {
    const awsRumSettings = config.awsRum;
    const region = awsRumSettings?.applicationRegion as "us-east-1";

    return process.env.REACT_APP_CONFIG_ENV !== "development" ? (
        <AwsRumReact
            allowCookies={awsRumSettings?.allowCookies}
            endpoint={awsRumSettings?.endpoint}
            id={awsRumSettings?.applicationId as string}
            identityPoolId={awsRumSettings?.identityPoolId}
            region={region}
            sessionSampleRate={awsRumSettings?.sessionSampleRate}
            telemetries={awsRumSettings?.telemetries}
            version={awsRumSettings?.applicationVersion as string}
            enableXRay={awsRumSettings?.enableXRay}
        >
            <ErrorBoundary>{children}</ErrorBoundary>
        </AwsRumReact>
    ) : (
        <>{children}</>
    );
}

export default AwsRumProvider;
